import React, { useEffect, useRef, useState } from 'react'
import {
  Slider,
  colors,
} from '@material-ui/core';
import { Icon } from 'components/atoms';

// import {
//   SkipPreviousOutlinedIcon,
//   SkipNextOutlinedIcon,
//   VolumeUpOutlinedIcon,
//   PlayArrowIcon,
//   PauseIcon,
// } from '@material-ui/icons';
import 'assets/css/musicPlay.css';

export default function MusicPlay({ musicInfoList }) {

  const musicRef = useRef()
  const [musicInfo, setMusicInfo] = useState([])
  const [musicIndex, setMusicIndex] = useState(0)
  const [musicSrc, setMusicSrc] = useState('')
  const [musicImg, setMusicImg] = useState('')
  const [musicName, setMusicName] = useState('')
  const [musicArt, setMusicArt] = useState('')
  const [currentTime, setCurrentTime] = useState(0)
  const [maxTime, setMaxTime] = useState('')
  const [musicVolume, setMusicVolume] = useState('')
  const [musicTimer, setMusicTimer] = useState('')
  const [musicPlay, setMusicPlay] = useState(false)

  useEffect(() => {
    if (musicInfoList) {
      if (musicInfo.length === 0) return setMusicInfo([...musicInfoList])
      setMusicImg("http://192.168.10.216:31839/assets/uploads/albums/168a143fc4d90c62cfa9f129c87d9732.png")
      setMusicName(musicInfo[musicIndex].albumName)
      setMusicArt(musicInfo[musicIndex].artistName)
      setMusicSrc(musicInfo[musicIndex].remotePath)
    }

  }, [musicInfo, musicInfoList])


  useEffect(() => {
    if (musicInfo.length == 0) return

    // const { musicName, musicArt, musicSrc } = musicInfo[musicIndex]

    setMusicName(musicInfo[musicIndex].albumName)
    setMusicArt(musicInfo[musicIndex].artistName)
    setMusicSrc(musicInfo[musicIndex].remotePath)
    setTimeout(playMusic, 500)

  }, [musicIndex])

  const songTimeFilter = (val) => {
    const dt = new Date(val * 1000)
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')
    return `${mm}:${ss}`
  }

  const playMusic = () => {
    if (musicSrc) {
      if (musicRef.current.paused) {
        if (!musicVolume) {
          musicRef.current.volume = 0.1
          setMusicVolume(0.1)
        }
        if (musicRef.current.error == null) {
          console.log("5555")
          musicRef.current.play()
        }
        watchMusicInfo()
        setMusicPlay(true)
      } else {
        musicRef.current.pause()
        setMusicPlay(false)
        clearInterval(musicTimer)
      }
    }
  }

  const watchMusicInfo = () => {
    clearInterval(musicTimer)
    setMaxTime(musicRef.current.duration)

    const theTimer = setInterval(() => {
      setMusicTimer(theTimer)

      if (musicRef.current) {
        if (musicRef.current.paused) {
          clearInterval(musicTimer)
          setMusicPlay(false)
        }
        if (musicRef.current.ended) {
          clearInterval(musicTimer)
          setMusicPlay(false)
          changePlayMusic(1)
        }

        setCurrentTime(musicRef.current.currentTime)
      }
    }, 500)
  }

  const changeMusicTime = (value) => {
    clearInterval(musicTimer)
    musicRef.current.currentTime = value
    if (musicRef.current.paused) musicRef.current.play()
    setMusicPlay(true)
    watchMusicInfo()
  }

  const setVolume = (val) => {
    if (!musicVolume) {
      musicRef.current.volume = 0.1
      setMusicVolume(0.1)
      return
    }
    if (!val) return
    musicRef.current.volume = val
  }
  const changePlayerVolume = (value) => {
    if (value == 0) return (musicRef.current.volume = 0)
    setMusicVolume(value / 10)
    setVolume(value / 10)
  }

  const formatter = (value) => songTimeFilter(value)

  const changePlayMusic = (num) => {
    const index = musicIndex + num
    if (index < 0) return setMusicIndex(musicInfo.length - 1)
    if (index >= musicInfo.length) return setMusicIndex(0)

    setMusicIndex(index)
  }

  const volumeClick = ()=>{
    const volume = document.querySelector(".volume")
    if(volume){
      if(volume.style.display=="none"){
        volume.style.display = "block"
      }else{
        volume.style.display = "none"
      }
      
    }
  }

  return (
    <>
      <div className='musicPlay'>

        <div className="musicBox">

          <div className='musicMain musicMain_md'>
            <audio ref={musicRef} type="audio" src={musicSrc}></audio>
            <div className="musicInfo">
              <div className="operationBar">
                <Icon
                  fontIconClass="fas fa-step-backward"
                  fontIconColor={"#fff"}
                  onClick={() => changePlayMusic(-1)}
                />
                {musicPlay ? (
                  <Icon
                    fontIconClass="far fa-pause"
                    fontIconColor={"#fff"}
                    onClick={playMusic}
                  />
                ) : (
                  <Icon
                    fontIconClass="fa fa-play"
                    fontIconColor={"#fff"}
                    onClick={playMusic}
                  />
                )}
                <Icon
                  fontIconClass="fas fa-step-forward"
                  fontIconColor={"#fff"}
                  onClick={() => changePlayMusic(1)}
                />
              </div>
            </div>
          </div>

          <div className="progressBar">
            <Slider
              tooltip={{ formatter }}
              value={5}
              // max={maxTime}
              onChange={(value) => setCurrentTime(value)}
            // onAfterChange={changeMusicTime}
            />
          </div>

          <div className="musicTime">
            {songTimeFilter(currentTime)} / {songTimeFilter(maxTime)}
          </div>

          <div className="musicDesc">
            Available on:
          </div>

          <div className='musicMain'>
            <audio ref={musicRef} type="audio" src={musicSrc}></audio>
            <div className="musicInfo">
              <div className="operationBar">
                <Icon
                  fontIconClass="fas fa-step-backward"
                  fontIconColor={"#fff"}
                  onClick={() => changePlayMusic(-1)}
                />
                {musicPlay ? (
                  <Icon
                    fontIconClass="far fa-pause"
                    fontIconColor={"#fff"}
                    onClick={playMusic}
                  />
                ) : (
                  <Icon
                    fontIconClass="fa fa-play"
                    fontIconColor={"#fff"}
                    onClick={playMusic}
                  />
                )}
                <Icon
                  fontIconClass="fas fa-step-forward"
                  fontIconColor={"#fff"}
                  onClick={() => changePlayMusic(1)}
                />
              </div>
            </div>
          </div>
          <div className="volume_icon">
            <Icon
              fontIconClass="fas fa-volume-down"
              fontIconColor={"#fff"}
              onClick={volumeClick}
              size='medium'
            />
          </div>

          <div className="volume">
            <Slider defaultValue={1} max={10} onChange={changePlayerVolume} />
          </div>
        </div>
      </div>

    </>

  )
}